import { Controller } from "stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["wrapper"];

  connect() {
    const wrapper = this.hasWrapperTarget ? this.wrapperTarget : this.element;

    Sortable.create(wrapper, {
      animation: 150,
      handle: ".sort-handle"
    });
  }
}
